import React, { useContext } from "react";

import { WalletItem } from "@components-shared/desktop/inputs/WalletItem";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react-lite";

export default observer(function WithdrawalWalletSelector() {
	const {
		onlineWallet,
		casinoWallet,
		liveCasinoWallet,
		gamesWallet,
		shouldShowWalletSelectors,
	} = useContext(WithdrawalContext);
	return (
		<ul className="wallet">
			<WalletItem
				wallet={onlineWallet}
				isList
				hidden={!shouldShowWalletSelectors}
			/>
			{WEBPACK_IS_CASINO_ENABLED ? (
				<WalletItem
					wallet={casinoWallet}
					isList={true}
					hidden={!shouldShowWalletSelectors}
				/>
			) : null}
			{THEME_SETTINGS.showLiveCasinoWalletPayment ? (
				<WalletItem
					wallet={liveCasinoWallet}
					isList={true}
					hidden={!shouldShowWalletSelectors}
				/>
			) : null}
			<WalletItem
				wallet={gamesWallet}
				isList
				hidden={!shouldShowWalletSelectors}
			/>
		</ul>
	);
});
